import React from 'react';
import Agreements from 'modules/Agreements/Agreements';
import LocalAgreements from 'modules/LocalAgreements/LocalAgreements';
import UnpaidOverview from './UnpaidOverview';
export default function Overview() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnpaidOverview, null), /*#__PURE__*/React.createElement(Agreements, null), /*#__PURE__*/React.createElement(LocalAgreements, null));
}